// Mailchimp subscription helper.
// Uses fetch with `no-cors` mode as a fire-and-forget submission since
// Mailchimp's embed endpoint does not send CORS headers for JS clients.
// The request still reaches Mailchimp and adds the subscriber; we just
// can't read the response body / status from the browser.

const MAILCHIMP_URL =
  "https://salumitucson.us10.list-manage.com/subscribe/post?u=3c7816c6f7a80e8e2a1ba8aeb&id=8752615e0a&f_id=00bef0e0f0";

// Honeypot field name (from Mailchimp embed) — must be empty for real users.
const MAILCHIMP_HONEYPOT = "b_3c7816c6f7a80e8e2a1ba8aeb_8752615e0a";

export async function subscribeToMailchimp(email) {
  if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
    return false;
  }

  const body = new URLSearchParams();
  body.append("EMAIL", email);
  body.append(MAILCHIMP_HONEYPOT, ""); // honeypot must be empty

  try {
    await fetch(MAILCHIMP_URL, {
      method: "POST",
      mode: "no-cors",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: body.toString(),
    });
    // With no-cors we cannot inspect the response, but the request is delivered.
    return true;
  } catch (err) {
    // Network-level failure only. CORS/opaque responses do not throw.
    return false;
  }
}
